export default {
  methods: {
    /* Validate routing number */
    /* Adapted from http://www.brainjar.com/js/validation/ */
    validateABA: function (aba) {
      if (typeof aba === 'undefined' || aba === null || !aba) {
        return false
      }

      if (aba.length !== 9) {
        return false
      }

      let total = 0

      for (let i = 0; i < aba.length; i += 3) {
        total += parseInt(aba.charAt(i), 10) * 3 + parseInt(aba.charAt(i + 1), 10) * 7 + parseInt(aba.charAt(i + 2), 10)
      }

      if (total !== 0 && total % 10 === 0) {
        return true
      } else {
        return false
      }
    },

    /* Validate card number with Luhn formula */
    /* Adapted from http://www.brainjar.com/js/validation/default2.asp */
    validateCardNumber: function (card) {
      if (typeof card === 'undefined' || card === null || !card) {
        return false
      }

      let sub = ''
      let total = 0

      let reversedCard = card.split('').reverse().join('')

      for (let i = 0; i < reversedCard.length; i++) {
        let c = parseInt(reversedCard.charAt(i), 10)
        if (i % 2 !== 0) {
          c *= 2
        }
        sub += c
      }

      for (let i = 0; i < sub.length; i++) {
        let c = parseInt(sub.charAt(i), 10)
        total += c
      }

      if (total !== 0 && total % 10 === 0) {
        return true
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validation.js